import {Component, Input, OnInit, ViewChild} from "@angular/core";
import {MatCalendar} from "@angular/material/datepicker";
import moment, {Moment} from "moment";
import {PredefinedDateSpanModel} from "../../models/predefined-date-span.model";
import { BehaviorSubject } from "rxjs";

@Component({
  selector: "pcg-ng-calendar-filter",
  template: require('./calendar-filter.component.html')
})
export class CalendarFilterComponent implements OnInit {
    @Input() public datesSpan$: BehaviorSubject<{startDate: string, endDate: string}> = new BehaviorSubject<{startDate: string, endDate: string}>({startDate: null, endDate: null});

    @ViewChild("startDatePicker", null) private startDatePicker: MatCalendar<Moment>;
    @ViewChild("endDatePicker", null) private endDatePicker: MatCalendar<Moment>;

    public predefinedValues: Array<PredefinedDateSpanModel> = [];
    public showCalendar = false;
    public current: {startDate: Moment, endDate: Moment} = {startDate: null, endDate: null};

    public constructor() { }

    public ngOnInit(): void {
        this.datesSpan$.subscribe((value) => {
            this.current.startDate = value.startDate ? moment(value.startDate) : null;
            this.current.endDate = value.endDate ? moment(value.endDate) : null;
        });

        this.predefinedValues.push(
            {
                label: "Day", isSelected: false, value: {
                    startDate: moment().startOf("day").add(1, "day"),
                    endDate: moment().endOf("day").startOf("second").add(1, "days")
                }
            },
            {
                label: "Week", isSelected: false, value: {
                    startDate: moment().startOf("day"),
                    endDate: moment().endOf("day").startOf("second").add(1, "week")
                }
            },
            {
                label: "Month", isSelected: false, value: {
                    startDate: moment().startOf("day"),
                    endDate: moment().endOf("day").startOf("second").add(1, "month")
                }
            },
        );
    }

    public emitValue(dateSpan: {startDate: Moment, endDate: Moment}): void {
        this.datesSpan$.next({
            startDate: dateSpan.startDate?.format(),
            endDate: dateSpan.endDate?.format()
        });
    }

    public onStartDateChanged(startDate: Moment): void {
        this.current.startDate = startDate.startOf("day");
        if (this.current.endDate?.isBefore(startDate)) {
            this.current.endDate = startDate.clone().endOf("day").startOf("second");
        }
        this.markPredefinedValue();
    }

    public onEndDateChanged(endDate: Moment): void {
        this.current.endDate = endDate.endOf("day").startOf("second");
        if (this.current.startDate?.isAfter(endDate)) {
            this.current.startDate = endDate.clone().startOf("day");
        }
        this.markPredefinedValue();
    }

    public valueExists(): boolean {
        return (this.current.startDate && this.current.startDate.isValid())
            && (this.current.endDate && this.current.endDate.isValid());
    }

    public onCancel(): void {
        this.setCurrentValue(this.datesSpan$.value);
        this.showCalendar = false;
    }

    public onSubmit(): void {
        if (this.valueExists()) {
            this.emitValue(this.current);
        }

        this.showCalendar = false;
    }

    public onPredefinedValueClicked(dateSpan: PredefinedDateSpanModel): void {
        this.predefinedValues.forEach(
            value => value.isSelected = value.label === dateSpan.label
        );

        this.emitValue(dateSpan.value);
    }

    private markPredefinedValue(): void {
        for (const predefined of this.predefinedValues) {
            predefined.isSelected = (predefined.value.startDate.isSame(this.current.startDate) && predefined.value.endDate.isSame(this.current.endDate));
        }
    }

    private setCurrentValue(value: {startDate: string, endDate: string}): void {
        this.current.startDate = moment(value?.startDate);
        this.current.endDate = moment(value?.endDate);
    }
}
